module.exports = "<!-- * ADMIN-PRESS-RELEASE * -->\n<router-outlet></router-outlet>"